export default "__VITE_ASSET__Bb4th3c6__$_?no-inline__"